import { createFileRoute } from '@tanstack/react-router';
import { AdminActivityDetailScreen } from '@/features/admin/AdminActivityDetailScreen';

export const Route = createFileRoute('/_app/admin/activity/$eventUuid')({
  component: () => {
    const { eventUuid } = Route.useParams();
    return <AdminActivityDetailScreen eventUuid={eventUuid} />;
  },
});
